import {useEffect, useState} from 'react';
import {Alert} from '@vector';
// Not yet wrapped by vector.
import {Skeleton} from 'antd';
import Layout from './components/Layout';
import brandLayoutProps from './components/brandLayoutProps';
import styles from './LegalPage.module.css';

/**
 * A brand's Terms of Use or Privacy page, e.g. /home/southafrica/terms.
 *
 * **Fetched rather than transcribed**, like the HOTmaths terms dialog (register/TermsDialog.js): the text is
 * an HTML fragment (home/southafrica/fragments/*.html) that the legacy Tiles page includes too, so there is one
 * copy of the legal text and nobody retypes it into JavaScript.
 *
 * `dangerouslySetInnerHTML` is safe here in the sense that matters: the content is a static file from our own
 * webapp, never anything a user supplies.
 */
export default function LegalPage({content, page}) {
    const [html, setHtml] = useState(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        document.title = `${page.title} - ${content.productName}`;
        let cancelled = false;
        fetch(page.fragment, {credentials: 'same-origin'})
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Request failed: ${response.status}`);
                }
                return response.text();
            })
            .then((body) => !cancelled && setHtml(body))
            .catch(() => !cancelled && setFailed(true));
        return () => {
            cancelled = true;
        };
    }, [page, content.productName]);

    return (
        <Layout {...brandLayoutProps(content)}>
            <div className={styles.page}>
                {failed && (
                    <>
                        <h1>{page.title}</h1>
                        <Alert type="error" showIcon
                               title={`We could not load the ${page.title.toLowerCase()}. Please reload the page.`}/>
                    </>
                )}
                {!html && !failed && <Skeleton active paragraph={{rows: 12}}/>}
                {/* The fragment carries its own <h1>. */}
                {html && <div className={styles.legal} dangerouslySetInnerHTML={{__html: html}}/>}
            </div>
        </Layout>
    );
}
